module.exports = __webpack_public_path__ + "img/parking-spots-no.e5b93815.svg";